import React from 'react'

import { IconProps } from '../Types'

export const MoveUp = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="MoveUp"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m4.85,4.88c.18-.18.44-.18.62,0l2.48,2.47c.27.37,0,.82-.35.82h-1.59v10.17c0,.46-.35.92-.89.92s-.88-.46-.88-.92v-10.17h-1.59c-.35,0-.53-.55-.27-.82l2.48-2.47Zm6.46,5.95h-1.77c-.53,0-.88-.46-.88-.92s.35-.92.88-.92h1.77c.53,0,.89.46.89.92s-.35.92-.89.92Zm5.31,4.21h-7.26c-.35,0-.71-.37-.71-.92s.27-.92.71-.92h7.26c.44,0,.71.37.71.92s-.26.92-.71.92Zm4.43,2.38h-11.68c-.44,0-.71.46-.71.92,0,.55.35.92.71.92h11.6c.44,0,.8-.37.8-.92,0-.46-.35-.92-.71-.92Z"/><path fill-rule="evenodd" d="m5.64,4.71l2.49,2.48v.02c.38.51.03,1.21-.54,1.21h-1.35v9.92c0,.57-.44,1.16-1.13,1.16s-1.13-.59-1.13-1.16v-9.92h-1.35c-.32,0-.52-.25-.6-.48-.08-.23-.05-.54.16-.76h0s2.48-2.47,2.48-2.47c.27-.28.7-.28.97,0Zm-.35.34c-.08-.08-.19-.08-.27,0h0s-2.48,2.47-2.48,2.47c-.05.06-.08.16-.04.27.04.11.1.14.13.14h1.84v10.41c0,.35.27.67.64.67s.64-.32.64-.67V7.93h1.84c.13,0,.31-.21.17-.43l-2.47-2.46Zm3.12,4.87c0-.56.44-1.16,1.13-1.16h1.77c.69,0,1.13.59,1.13,1.16s-.44,1.16-1.13,1.16h-1.77c-.69,0-1.13-.59-1.13-1.16Zm1.13-.67c-.37,0-.64.32-.64.67s.27.67.64.67h1.77c.37,0,.64-.32.64-.67s-.27-.67-.64-.67h-1.77Zm-.89,4.08c.17-.22.42-.35.71-.35h7.26c.3,0,.55.13.72.35.16.21.24.5.24.81s-.07.6-.24.81c-.17.22-.42.35-.72.35h-7.26c-.53,0-.95-.52-.95-1.16,0-.31.07-.6.24-.81Zm.39.29c-.08.11-.14.28-.14.52,0,.46.29.67.46.67h7.26c.15,0,.25-.06.33-.16.08-.11.14-.28.14-.52s-.06-.41-.14-.52c-.08-.1-.18-.16-.33-.16h-7.26c-.15,0-.25.06-.33.16Zm0,4.24c-.09.13-.14.3-.14.49,0,.46.29.67.46.67h11.6c.28,0,.55-.23.55-.67,0-.17-.07-.35-.17-.48-.11-.14-.22-.19-.29-.19h-11.68c-.13,0-.23.06-.32.18Zm-.4-.28c.16-.22.4-.39.72-.39h11.68c.28,0,.52.18.68.38.16.21.27.49.27.78,0,.66-.44,1.16-1.04,1.16h-11.6c-.53,0-.95-.52-.95-1.16,0-.27.08-.55.23-.77Z"/>',
    }}
  />
)

MoveUp.displayName = 'MoveUp'

export const tags = ['MoveUp', '']
